import dayjs from 'dayjs';
import { useState } from 'react';

import { Box } from '@mui/material';
import Button from 'components/Button';
import DatePickerMaterialUI from 'components/DatePicker';
import Modal from 'components/Dialog';
import Typography from 'components/Typography';

import {
  colors,
  displayFlexAlignItemsCenterJustifyContentFlexStart,
  displayFlexAlignItemsCenterJustifyContentSpaceBetween,
  flexDirection,
  tokens,
} from 'styles';

const FilterDateModal = ({ open, handleClose, handleSubmit }) => {
  const [fromDate, setFromDate] = useState(dayjs(Date.now()));
  const [toDate, setToDate] = useState(dayjs(Date.now()));
  return (
    <Modal open={open} handleClose={handleClose} title='Filter Date'>
      <Box {...displayFlexAlignItemsCenterJustifyContentSpaceBetween} gap={'15px'}>
        <Box
          {...displayFlexAlignItemsCenterJustifyContentFlexStart}
          {...flexDirection.column}
          alignItems='start'
          gap={'10px'}
          mb={3}
        >
          <Typography token={tokens.FS16FW500LH19_2M} color={colors.whiteFF} text={'From Date'} textAlign='left' />
          <DatePickerMaterialUI
            value={fromDate}
            onDateChange={(newValue) => setFromDate(newValue)}
            disablePast={false}
            maxDate={toDate}
          />
        </Box>
        <Box
          {...displayFlexAlignItemsCenterJustifyContentFlexStart}
          {...flexDirection.column}
          alignItems='start'
          gap={'10px'}
          mb={3}
        >
          <Typography token={tokens.FS16FW500LH19_2M} color={colors.whiteFF} text={'To Date'} textAlign='left' />
          <DatePickerMaterialUI
            value={toDate}
            onDateChange={(newValue) => setToDate(newValue)}
            disablePast={false}
            minDate={fromDate}
          />
        </Box>
      </Box>
      <Button
        variant='white'
        text='Filter'
        onClick={() => handleSubmit(fromDate.toDate(), toDate.toDate())}
        token={tokens.FS20FW500LH24M}
        maxWidth={true}
        padding={'15px'}
      />
    </Modal>
  );
};

export default FilterDateModal;
